@if (conseil$ | async; as conseil) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">{{conseil.titre}} - <small>{{conseil.date | date:'dd/MM/y'}}</small></h2>
    </div>
    <div class="m-2 p-4 mb-5 bg-white rounded">
      @if (conseil.image) {
        <app-cover [image]="conseil.image.url" ></app-cover>
      }
      <div class="mt-3" [innerHTML]="contenu"></div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
      <a class="btn btn-light" routerLink="/conseils">Fermer</a>&nbsp;
    </nav>
  </section>
}
